import React from "react";
import "./SocialMedia.css";
import { socialMediaLinks } from "../../portfolio";
import styled from "styled-components";

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.highlight};
  transition: all 0.3s ease-in-out;

  i {
    color: ${(props) => props.theme.text};
    font-size: 20px;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    background-color: ${(props) => props.theme.text};
    transform: translateY(-3px);
    i {
      color: ${(props) => props.theme.body};
    }
  }
`;

export default function SocialMedia(props) {
  const getIconClass = (iconName) => {
    if (!iconName) return "fas fa-link";
    if (
      iconName.startsWith("fab ") ||
      iconName.startsWith("fas ") ||
      iconName.startsWith("far ")
    ) {
      return iconName;
    }
    return `fab ${iconName}`;
  };

  if (!socialMediaLinks || socialMediaLinks.length === 0) {
    return null;
  }

  return (
    <div className="social-media-div">
      {socialMediaLinks.map((media, i) => {
        return (
          <a
            key={i}
            href={media.link || "#"}
            className="icon-button"
            target={media.link ? "_blank" : "_self"}
            rel="noopener noreferrer"
            aria-label={media.name}
          >
            <IconWrapper theme={props.theme}>
              <i className={getIconClass(media.fontAwesomeIcon)}></i>
            </IconWrapper>
          </a>
        );
      })}
    </div>
  );
}
